import { Link } from "react-router-dom";
import hourglassIcon from "@/assets/hourglass-logo.webp";
import wordmark from "@/assets/rentify-wordmark.png";

interface RentifyLogoProps {
  size?: "sm" | "md" | "lg";
  linkToHome?: boolean;
  className?: string;
  showIcon?: boolean;
  mobile?: boolean;
}

const RentifyLogo = ({ size = "md", linkToHome = true, className = "", showIcon = true, mobile = false }: RentifyLogoProps) => {
  const iconHeights = {
    sm: 44,
    md: mobile ? 36 : 56,
    lg: 64,
  };

  const wordmarkHeights = {
    sm: 44,
    md: mobile ? 36 : 60,
    lg: 72,
  };

  const iconH = iconHeights[size];
  const wordH = wordmarkHeights[size];

  const content = (
    <div className={`flex items-center gap-2 ${className}`}>
      {showIcon && (
        <img
          src={hourglassIcon}
          alt="Rentify"
          className="flex-shrink-0 object-contain"
          style={{ height: iconH, width: iconH }}
        />
      )}
      <span
        className="text-foreground leading-none tracking-tight"
        style={{ fontSize: wordH * 0.55, fontFamily: "'bogart', 'Inter', sans-serif", fontWeight: 500 }}
      >
        Rentify
      </span>
    </div>
  );

  if (linkToHome) {
    return (
      <Link
        to="/"
        className="flex items-center hover:opacity-90 transition-opacity"
        aria-label="Rentify home"
      >
        {content}
      </Link>
    );
  }

  return content;
};

export default RentifyLogo;
